const titleName = (vendors, filterSelected) => {
  let filterNumber = parseInt(filterSelected)
  let filter = ''
  vendors.some(function (el, i) {
    if (el.id === filterNumber) filter = el.name
  })
  return filter
}

export default titleName



// WEBPACK FOOTER //
// ./src/Catalog/Search/Search/Title.js